export default class ShowcaseCollection
{
	constructor(collection)
	{
		this.setShowcases(collection);
	}

	setShowcases(collection)
	{
		this.collection = collection;

		return this;
	}

	getShowcases()
	{
		return this.collection;
	}

	filterByAffix(affix)
	{
		return new ShowcaseCollection(Array.from(this.getShowcases().filter(showcase => {
			return showcase.getAffix() == affix;
		}).values()));
	}

	filterByCategory(category)
	{
		return new ShowcaseCollection(Array.from(this.getShowcases().filter(showcase => {
			return showcase.getCategory() == category;
		}).values()));
	}

	setFromResponse(response)
	{
		this.getShowcases().map(showcase => {
			showcase.setFromResponse(response);
		});

		return this;
	}

	setFromQueryResponse(response)
	{
		this.getShowcases().map(showcase => {
			showcase.setFromQueryResponse(response);
		});

		return this;
	}

	hide()
	{
		this.getShowcases().map(showcase => {
			showcase.hide();
		});

		return this;
	}

	show()
	{
		this.getShowcases().map(showcase => {
			showcase.show();
		});

		return this;
	}

	showNotEmpty()
	{
		this.getShowcases().map(showcase => {
			showcase.showNotEmpty();
		});

		return this;
	}
}
